import { mapGetters } from 'vuex'
export default {
  methods: {

    ...mapGetters([
      'getBreadCrumb'
    ]),

    gotToPath (path) {
      if (this.$route.name === 'categories' && path.indexOf('categories') > -1){
        this.removeScroll()
      }
      if (path === '/home') {
        this.$store.state.searchTerm = null
      }
      this.$router.push({path:path})
    },

    back () {
      let bc = this.getBreadCrumb()
      console.log(bc)
      if (bc.length > 1) {
        // console.log('set new scroll1', bc[bc.length -1].from.name, bc[bc.length -1].scrollY )
        // navigation behaviour to back to categories
        if (bc[bc.length -1].from.name === 'categories') {
          this.$store.state.breadCrumbSavedPosition = {x: 0, y: bc[bc.length -1].scrollY}
          this.$store.state.lastLimitProducts = bc[bc.length -1].lastLimitProducts
          // console.log('set new scroll2', this.$store.state.lastLimitProducts)
        } else {
          this.removeScroll()
        }
      }
      if (bc.length === 1 && bc[0].from.fullPath === '/home') {
        this.$router.push({path:'/home'})
      } else if (bc.length > 1){
        // do not infinite lopping product cart
        console.log(bc[bc.length -1].from.name, bc[bc.length -2].from.name)
        if (bc[bc.length -1].from.name === 'cart' && bc.length > 1 && bc[bc.length -2].from.name === 'product2') {
          this.$router.push({path:'/home'})
        } else {
          // do not back to fake modal
          if (bc[bc.length -1].from.name !== 'card' &&  bc[bc.length -1].from.name !== 'address' && bc[bc.length -1].from.name !== 'register' && bc[bc.length -1].from.name !== this.$router.currentRoute.name) {
            this.$router.push({path:bc[bc.length -1].from.fullPath})
          } else if (bc.length > 1 && (bc[bc.length -2].from.name !== 'card' &&  bc[bc.length -2].from.name !== 'address' && bc[bc.length -2].from.name !== 'register' && bc[bc.length -2].from.name !== this.$router.currentRoute.name)) {
            this.$router.push({path:bc[bc.length -2].from.fullPath})
          } else {
            this.$router.push({path:'/home'})
          }
        }
      } else {
        this.$router.push({path:'/home'})
      }
    },

    close () {

    },

    removeScroll () {
      this.$store.state.lastLimitProducts = 20
      this.$store.state.breadCrumbSavedPosition = {x: 0, y: 0}
    },


    distanceBeetwen2LatLng (lat1, lon1, lat2, lon2) {
      let R = 6371 // Radius of the earth in km
      let dLat = this.deg2rad(lat2-lat1)  // deg2rad below
      let dLon = this.deg2rad(lon2-lon1)
      let a = 
        Math.sin(dLat/2) * Math.sin(dLat/2) +
        Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * 
        Math.sin(dLon/2) * Math.sin(dLon/2)
      let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a))
      let d = R * c // Distance in km
      if ( d < 1) {
        return (d * 1000).toFixed(2).replace('.', ',') + 'm'
      } else {
        return d.toFixed(2).replace('.', ',') + 'km'
      }
    },
    
    deg2rad (deg) {
      return deg * (Math.PI/180)
    }

  }
}